// @flow
import type { VoucherAddMoneyActionType } from './actions';

export const voucherAddMoneyReducer = (state: Object = {}, action: VoucherAddMoneyActionType) => {
  switch (action.type) {
    case 'FETCH_VOUCHER_REQUEST':
    case 'FETCH_VOUCHER_FAILURE':
      return {
        ...state,
        amount: null,
      };
    case 'SET_VOUCHER':
      return action.payload.voucher;
    case 'UPDATE_VOUCHER_CODE':
      return {
        ...state,
        externalId: action.payload.code,
      };
    case 'CLEAR_VOUCHER_DATA':
      return {};
    default:
      return state;
  }
};
